import React, { useEffect, useState, forwardRef, useRef } from 'react';
import {connect, useSelector} from "react-redux";
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { Select, Modal, Tooltip, Skeleton, notification, Spin, Switch } from 'antd';
import DatePicker from 'react-datepicker'
import { formatPhoneNumber, getCookie, lightOrDark, SUPPORT_URL } from '../../helpers/globals';
import { dateFormat, formatHours, formatNumber } from '../../helpers/stringFormat';
import { grayColor } from '../../helpers/globals';
import { saveCheck, plus } from '../../fakeData/svgFiles';
import VinSmartScanner from './VinSmartScanner';
import {
    getAllAssignableUsers,
    createNewJob,
    getJobByOrg,
    unAssignJobColor,
    debouncedGetCustomers,
    debouncedCreateNewJob,
    debouncedGetChooseJob
} from '../../store/job/actions';
import { getNoteList } from '../../store/note/actions';
import AddNodes from '../modals/AddNodes';
import { FilledLightButton } from '@oneblinktech-org/helios-base';
import { createApiClient, ApiSpin, FilledBrightButton } from '@oneblinktech-org/helios-base';
import PhotoManagement from './photoManagement';
import Dots from '../Dots';
import Editable from '../Editable';
import Block from '../common/block';
import Customer from '../Customer';
import _set from 'lodash/set';
import DraftEditor from './DraftEditor';
import { differenceInMinutes } from 'date-fns'
import Lightbox from 'react-image-lightbox';
import ReactSelect from 'react-select'
import Avatar from '../Avatar';
import searchIcon from '../../assets/images/search.svg';
import { initializePusher, unbindPusher } from '../../pusherManager';
import AutoSelectOnTab from '../AutoSelectOnTab';
import { createWorker, PSM } from 'tesseract.js';
import { PERMISSIONS } from "../../constants/permissions";
import { useModalBackButton } from '../../hooks/useModalBackButton';

const apiUrl = process.env.REACT_APP_API_URL;
const { get, post, put } = createApiClient({ apiUrl });
const dot = () => ({
    alignItems: 'center',
    display: 'flex',
  
    ':before': {
        backgroundImage: `url(${searchIcon})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 15,
        width: 18,
    },
  });
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: 'var(--input-text)',
        backgroundColor: state.isSelected ? 'var(--job-ro-number)' : '$blue-focus-bg',
        ':hover': {
            backgroundColor: 'var(--job-card-hover-bg)',
        },
    }),
    control: (provided) => ({
        ...provided,
        marginTop: "5%",
        backgroundColor: '$blue-focus-bg',
        color: '$gray-darker'
    }),
    singleValue: (styles, { data }) => ({
        ...styles, backgroundColor: '$blue-focus-bg',
        ...dot()
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        display: state.hasValue ? 'none' : ''
    }),
    input: (styles) => ({
        ...styles,
        color: 'var(--job-name)',
        ...dot()
    }),
    placeholder: (styles) => ({ ...styles, ...dot() }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: 'var(--primary-background)',
    }),
}

const getStoredDetailView = (defaultValue = true) => {
    if (typeof window === 'undefined') {
        return defaultValue;
    }

    const storedValue = localStorage.getItem('showDetail');

    if (storedValue === null) {
        return defaultValue;
    }

    return storedValue === 'true';
};

const JobDetail = (props) => {
    const history = useHistory();
    const [isDark, setIsDark] = useState("dark");
    const jobStatuses = props.jobStatuses.data;
    const [assignableUsers, setAssignableUsers] = useState([]);
    const [jobItem, setJobItem] = useState(props?.item);
    const [changed, setChanged] = useState(false)
    const [noteOpen, setNoteOpen] = useState(false);
    const [archiveOpen, setArchiveOpen] = useState(false);
    const [replyNoteOpen, setReplyNoteOpen] = useState(false);
    const [singleNote, setSingleNote] = useState({})
    const [currentNoteIndex, setCurrentNoteIndex] = useState(0)
    const [focusField, setFocusField] = useState('')
    const Option = Select.Option;
    const [years, setYears] = useState([])
    const [activityOpen, setACtivityOpen] = useState(localStorage.getItem('activityOpen') ?? true)
    const [jobValue, setJobValue] = useState(jobItem?.value)
    const [jobInDate, setJobInDate] = useState(props?.item?.in_date)
    const [jobOutDate, setJobOutDate] = useState(props?.item?.out_date)
    const [jobArchiveAt, setJobArchiveAt] = useState(props?.item?.archived_at)
    const [showSendCustomerBtn, setShowSendCustomerBtn] = useState(false)
    const [showEditor, setShowEditor] = useState(false)
    const [comment, setComment] = useState('')
    const [plainComment, setPlainComment] = useState("")
    const [attachments, setAttachments] = useState([])
    const [isReset, setReset] = useState(false)
    const [isSaved, setSaved] = useState(false)
    const [lightBoxImages, setLightBoxImages] = useState([])
    const [imageIndex, setImageIndex] = useState(0)
    const [isOpenLightBox, setOpenLightBox] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [customer, setCustomer] = useState('')
    const [isUpdateCustomer, setUpdateCustomer] = useState(false)
    const isNewJob = props.isNewJob
    const [customers, setCustomers] = useState([])
    const [search, setSearch] = useState("")
    const [showDetail, setShowDetail] = useState(() => getStoredDetailView(true))

    const fileInputRef = useRef(null)
    const [isScanningVin, setIsScanningVin] = useState(false)
    const isMobileDevice = typeof navigator !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    const [showVinScanner, setShowVinScanner] = useState(false);
    const { planning_count, production_count } = props?.countData
    const orgId = getCookie('active_organization_id')

    const { permissions } = useSelector((state) => state.PermissionReducer);
    const canSeeJobValue = permissions.includes(PERMISSIONS.JOB_VALUE_VIEW);
    const canAddFile = permissions.includes(PERMISSIONS.JOB_ADD_FILE);
    const canDeleteFile = permissions.includes(PERMISSIONS.JOB_DELETE_FILE);
    const canSeeNote = permissions.includes(PERMISSIONS.JOB_NOTE_VIEW);
    const canCreateNote = permissions.includes(PERMISSIONS.JOB_NOTE_CREATE);
    const canCreateNoteAndSend = permissions.includes(PERMISSIONS.JOB_NOTE_CREATE_AND_SEND);
    const canSetInOutDate = permissions.includes(PERMISSIONS.JOB_SET_IN_OUT_DATE);
    const canUpdateJobColor = permissions.includes(PERMISSIONS.JOB_CARD_COLOR_UPDATE);
    const canUpdateJobDot = permissions.includes(PERMISSIONS.JOB_CARD_DOT_UPDATE);
    const canUpdateJobArchive = permissions.includes(PERMISSIONS.JOB_ARCHIVE_UNARCHIVE);
    const canSeeJobCustomerName = permissions.includes(PERMISSIONS.JOB_CUSTOMER_NAME_VIEW);
    const canAssignCustomer = permissions.includes(PERMISSIONS.JOB_ASSIGN_CUSTOMER);
    const canUpdateJobStatus = permissions.includes(PERMISSIONS.JOB_STATUS_UPDATE);

    const handleCloseArchiveModal = () => {
        setArchiveOpen(false)
    }

    useModalBackButton(archiveOpen, handleCloseArchiveModal)

    useEffect(() => {
        if (Object.values(props.item).length > 0) {
            setJobItem(props.item);
            setJobInDate(props?.item?.in_date)
            setJobOutDate(props?.item?.out_date)
            setJobArchiveAt(props?.item?.archived_at)
            setJobValue(props.item?.value)
            props.getAllAssignableUsers()
        }
    }, [props.item]);

    useEffect(() => {
        if (Object.keys(props.customer.data).length > 0 && !props.customer.loading) {
            setJobItem((prev) => {
                const newData = {
                    ...prev,
                    customer: props.customer.data
                }
                return newData;
            })
            setUpdateCustomer(false)
         }
    },[isUpdateCustomer, props.customer.data, props.customer.loading])

    useEffect(() => {
        if (Object.values(props.item).length > 0) {
            if (props.customers.fetched)
                setCustomers(props.customers.data)
            else if (!props.customers.loading)
                props.debouncedGetCustomers()
        }
    }, [props.customers.fetched, props.customers.loading, props.item])

    useEffect(() => {
        if (isNewJob) {
            setCustomer(null)
        }
    }, [isNewJob])

    const [isAlertShow, setAlertShow] = useState(false)
    const [isAlertLoading, setAlertLoading] = useState(false)
    const [isError, setISError] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")
    const [isSuccess, setIsSuccess] = useState(false)

    useEffect(() => {
        const years = range((new Date()).getFullYear() + 1, 1970, -1)
        setYears(years)
        if (Object.keys( props?.jobStatuses.data)?.length === 0)
            props.getJobByOrg()
    }, [])

    useEffect(() => {
        if (props.assignableUsers.data) {
            setAssignableUsers([{ "id": -1, firstname: 'Unassigned', lastname: '' }, ...Object.values(props.assignableUsers.data)])
        }
    }, [props.assignableUsers.data])


    useEffect(() => {
        if (changed && jobItem?.id) {
            setTimeout(async () => {
                const hasAssignUserExist = await props.assignableUsers.data?.find((i) => i.id === jobItem?.assigned_to_user_id)
                props.createNewJob({ ...jobItem, assigned_to_user_id: hasAssignUserExist ? jobItem.assigned_to_user_id : -1 }, 1)
                setChanged(false)
            }, 100)
        }
    }, [changed]);

    useEffect(() => {
        const { isSuccess, message, isUpdating } = props?.newJob
        setAlertLoading(isUpdating)
        setIsSuccess(isSuccess)
        setISError(isSuccess === false)
        setErrorMsg(message)
    }, [props.newJob])

    useEffect(() => {
        if (jobItem?.customer && isNewJob && !jobItem?.id){
            createJob(jobItem?.customer)
        }
    }, [jobItem?.customer])
    
    const directEditJob = () => {
        setTimeout(function () {
            history.push(`/job/edit/` + jobItem.id)
        }, 1000)
    }

    const onOpenNote = (note, index) => {
        setNoteOpen(true)
        setSingleNote(note)
        setCurrentNoteIndex(index)
        if (!note.read_at) {
            try {
                const token = localStorage.getItem('h-access_token')

                get(`/notes/${note.id}/mark_read`, {
                    "Authorization": `Bearer ` + token
                }).then(result => {
                    if (result?.success == 'Mark as read') {
                        let changedNoteIndex = props.notes.findIndex(data => data.id == note.id);
                        if (changedNoteIndex !== -1) {
                            props.notes[changedNoteIndex].read_at = true
                        }

                        props.getJobByOrg()
                    }
                }).catch(e => {
                    return e
                })
            } catch (error) {
                console.error("Error sending data:", error);
            }
        }
    }

    const onMoveNote = (nextIndex) => {
        setCurrentNoteIndex(nextIndex)
        if (props?.notes[nextIndex]) {
            setSingleNote(props?.notes[nextIndex])
        }
    }

    const focusOutOnEnter = (key, value, field, mainFieldPath, defaultValue) => {
        const regx = /^[A-HJ-NPR-Z0-9]{17}$/g
        if (!regx.test(value) && field === 'vehicle_vin' && (key === 'Enter' || key === 'Tab') && value !== defaultValue) {
            notification.open({
                type: 'warning',
                message: 'Alert!',
                description: 'Please enter valid VIN number',
                onClick: () => {
                },
            });
            return;
        }
        if (key === 'Enter' || key === 'Tab' || key === 'blur') {
            if (value !== defaultValue) {
                setJobItem((prev) => {
                    const newData = { ...prev, [field]: field === 'value' && value === '' ? jobValue : value };
                    if (mainFieldPath)
                        _set(newData, mainFieldPath, value);
                    return newData;
                })
                if (jobItem?.id) {
                    setChanged(true)
                    setAlertShow(true)
                }
            }
        }
        if (key === 'Enter')
            setFocusField('')
        if (field === 'value' && focusField === 'job_value' && key === 'Tab')
            setTimeout(() => setFocusField(''), 0);
    }

const getImageSize = (file) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            URL.revokeObjectURL(objectUrl);

            resolve({
                width: img.width,
                height: img.height,
            });
        };

        img.onerror = (error) => {
            URL.revokeObjectURL(objectUrl);
            reject(error);
        };

        img.src = objectUrl;
    });
};

const getVinCropRegions = (width, height) => {
    const ratio = width / height;

    const regions = [];

    // If image is already wide/short, it is probably already cropped VIN area.
    if (ratio >= 2.4) {
        regions.push({
            name: 'full-wide-image',
            x: 0,
            y: 0,
            w: 1,
            h: 1,
        });

        regions.push({
            name: 'middle-wide-strip',
            x: 0.03,
            y: 0.18,
            w: 0.94,
            h: 0.64,
        });

        return regions;
    }

    // Full image first, but only for a quick pass.
    regions.push({
        name: 'full-image',
        x: 0,
        y: 0,
        w: 1,
        h: 1,
    });

    // Common windshield VIN location: middle area
    regions.push({
        name: 'center-vin-window',
        x: 0.25,
        y: 0.28,
        w: 0.55,
        h: 0.35,
    });

    // Your Mercedes image style
    regions.push({
        name: 'center-right-vin-window',
        x: 0.36,
        y: 0.34,
        w: 0.45,
        h: 0.25,
    });

    // Your Honda image style
    regions.push({
        name: 'middle-lower-vin-window',
        x: 0.32,
        y: 0.36,
        w: 0.50,
        h: 0.28,
    });

    // BMW image style: VIN label is on left/middle
    regions.push({
        name: 'left-middle-vin-window',
        x: 0.18,
        y: 0.25,
        w: 0.55,
        h: 0.35,
    });

    // Wide horizontal scan strip
    regions.push({
        name: 'middle-horizontal-strip',
        x: 0.05,
        y: 0.25,
        w: 0.90,
        h: 0.45,
    });

    return regions;
};

const preprocessVinImage = (
    file,
    region,
    {
        scale = 4,
        contrast = 2.2,
        threshold = null,
        invert = false,
    } = {}
) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            try {
                const sx = Math.round(img.width * region.x);
                const sy = Math.round(img.height * region.y);
                const sw = Math.round(img.width * region.w);
                const sh = Math.round(img.height * region.h);

                const canvas = document.createElement('canvas');

                canvas.width = Math.max(1200, Math.round(sw * scale));
                canvas.height = Math.max(220, Math.round(sh * scale));

                const ctx = canvas.getContext('2d', {
                    willReadFrequently: true,
                });

                ctx.drawImage(
                    img,
                    sx,
                    sy,
                    sw,
                    sh,
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;

                for (let i = 0; i < data.length; i += 4) {
                    const r = data[i];
                    const g = data[i + 1];
                    const b = data[i + 2];

                    let lum = 0.299 * r + 0.587 * g + 0.114 * b;

                    // contrast
                    lum = (lum - 128) * contrast + 128;

                    if (threshold !== null) {
                        lum = lum > threshold ? 255 : 0;
                    }

                    if (invert) {
                        lum = 255 - lum;
                    }

                    const v = Math.max(0, Math.min(255, Math.round(lum)));

                    data[i] = v;
                    data[i + 1] = v;
                    data[i + 2] = v;
                }

                ctx.putImageData(imageData, 0, 0);

                canvas.toBlob((blob) => {
                    URL.revokeObjectURL(objectUrl);

                    if (!blob) {
                        reject(new Error('Failed to create OCR image blob.'));
                        return;
                    }

                    resolve(blob);
                }, 'image/png');
            } catch (error) {
                URL.revokeObjectURL(objectUrl);
                reject(error);
            }
        };

        img.onerror = (error) => {
            URL.revokeObjectURL(objectUrl);
            reject(error);
        };

        img.src = objectUrl;
    });
};

const extractVin = (text) => {
    if (!text) return null;

    const cleaned = normalizeVinOcrText(text);

    console.log('RAW OCR TEXT:', text);
    console.log('CLEANED OCR TEXT:', cleaned);
    console.log('CLEANED LENGTH:', cleaned.length);

    const candidates = [];

    if (cleaned.length === 17 && /^[A-HJ-NPR-Z0-9]{17}$/.test(cleaned)) {
        candidates.push(cleaned);
    }

    for (let pos = 0; pos <= cleaned.length - 17; pos++) {
        const chunk = cleaned.slice(pos, pos + 17);

        if (/^[A-HJ-NPR-Z0-9]{17}$/.test(chunk)) {
            candidates.push(chunk);
        }
    }

    const uniqueCandidates = [...new Set(candidates)];

    console.log('VIN CANDIDATES:', uniqueCandidates);

    for (const candidate of uniqueCandidates) {
        const fixedResult = fixVinCheckDigitIfNeeded(candidate);

        console.log('VIN CHECK:', {
            candidate,
            actual: candidate[8],
            expected: vinCheckDigit(candidate),
            fixedResult,
        });

        if (fixedResult?.vin) {
            return fixedResult;
        }
    }

    return null;
};

const vinCheckDigit = (vin) => {
    const transliteration = {
        A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8,
        J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9,
        S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9,
        0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9,
    };

    const weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

    vin = String(vin || '').toUpperCase();

    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) {
        return null;
    }

    let sum = 0;

    for (let i = 0; i < 17; i++) {
        const value = transliteration[vin[i]];

        if (value === undefined) {
            return null;
        }

        sum += value * weights[i];
    }

    const remainder = sum % 11;

    return remainder === 10 ? 'X' : String(remainder);
};

const normalizeVinOcrText = (text) => {
    return String(text || '')
        .toUpperCase()
        .replace(/O/g, '0')
        .replace(/Q/g, '0')
        .replace(/I/g, '1')
        .replace(/[^A-Z0-9]/g, '');
};

const fixVinCheckDigitIfNeeded = (candidate) => {
    if (!candidate || candidate.length !== 17) {
        return null;
    }

    const expectedCheckDigit = vinCheckDigit(candidate);

    if (!expectedCheckDigit) {
        return null;
    }

    if (candidate[8] === expectedCheckDigit) {
        return {
            vin: candidate,
            confidence: 'high',
            rawCandidate: candidate,
        };
    }

    const correctedVin =
        candidate.substring(0, 8) +
        expectedCheckDigit +
        candidate.substring(9);

    if (correctedVin[8] === vinCheckDigit(correctedVin)) {
        return {
            vin: correctedVin,
            confidence: 'check_digit_corrected',
            rawCandidate: candidate,
        };
    }

    return null;
};

const readVinFromImage = async (file) => {
    const worker = await createWorker('eng');

    try {
        await worker.setParameters({
            tessedit_char_whitelist: 'ABCDEFGHJKLMNPRSTUVWXYZ0123456789',
            tessedit_pageseg_mode: '7',
            preserve_interword_spaces: '0',
        });

        const imageInfo = await getImageSize(file);

        const cropRegions = getVinCropRegions(imageInfo.width, imageInfo.height);

        const processOptions = [
            { scale: 3, contrast: 1.8, threshold: null, invert: false },
            { scale: 4, contrast: 2.4, threshold: 140, invert: false },
            { scale: 4, contrast: 2.8, threshold: 160, invert: false },
            { scale: 4, contrast: 2.4, threshold: 140, invert: true },
        ];

        let bestRawText = '';
        let allLogs = [];

        for (let r = 0; r < cropRegions.length; r++) {
            const region = cropRegions[r];

            for (let p = 0; p < processOptions.length; p++) {
                const option = processOptions[p];

                try {
                    const blob = await preprocessVinImage(file, region, option);

                    const {
                        data: { text },
                    } = await worker.recognize(blob);

                    bestRawText += `\n${text}`;

                    const result = extractVin(text);

                    allLogs.push({
                        region: region.name,
                        process: option,
                        rawText: text,
                        result,
                    });

                    console.log(`VIN OCR region=${region.name}, process=${p}`, text);
                    console.log('VIN OCR result:', result);

                    if (result?.vin && result.confidence === 'high') {
                        return {
                            success: true,
                            vin: result.vin,
                            confidence: result.confidence,
                            rawCandidate: result.rawCandidate,
                            rawText: text,
                            debug: allLogs,
                        };
                    }

                    // For corrected VIN, return it but let handleVinImage ask confirmation
                    if (result?.vin) {
                        return {
                            success: true,
                            vin: result.vin,
                            confidence: result.confidence,
                            rawCandidate: result.rawCandidate,
                            rawText: text,
                            debug: allLogs,
                        };
                    }
                } catch (error) {
                    console.warn(`VIN OCR failed region=${region.name}, process=${p}`, error);
                }
            }
        }

        console.warn('VIN OCR all failed:', allLogs);

        return {
            success: false,
            vin: null,
            confidence: null,
            rawCandidate: null,
            rawText: bestRawText,
            debug: allLogs,
        };
    } finally {
        await worker.terminate();
    }
};

const handleVinBoxCaptured = async (file) => {
    /**
     * OCR path.
     * This only runs when user manually taps "Capture VIN Text".
     */
    setIsScanningVin(true);

    try {
        const result = await readVinFromImage(file);

        if (!result?.vin) {
            notification.warning({
                message: 'VIN Decode Failed',
                description: 'VIN text not detected. Please try again or enter manually.',
            });

            setIsScanningVin(false);
            return {
                success: false,
            };
        }

        const decoded = await decodeVinAndUpdateJob(result.vin);

        return {
            success: decoded,
            vin: result.vin,
        };
    } catch (error) {
        console.error('VIN OCR error:', error);

        notification.warning({
            message: 'VIN Decode Failed',
            description: 'Could not read VIN text. Please try again or enter manually.',
        });

        setIsScanningVin(false);

        return {
            success: false,
        };
    }
};

const handleVinBarcodeDetected = async ({ vin, rawValue, format, source }) => {
    /**
     * Barcode-only path.
     * Important:
     * - No OCR here
     * - Scanner should close only after backend decode succeeds.
     * - If backend rejects the VIN, child scanner will keep scanning.
     */
    setIsScanningVin(true);

    console.log('VIN barcode raw value:', {
        vin,
        rawValue,
        format,
        source,
    });

    const decoded = await decodeVinAndUpdateJob(vin);

    if (decoded) {
        setShowVinScanner(false);
    }

    return {
        success: decoded,
        vin,
    };
};

const decodeVinAndUpdateJob = async (vin) => {
    if (!vin) {
        notification.warning({
            message: 'VIN Decode Failed',
            description: 'VIN not found.',
        });

        setIsScanningVin(false);
        return false;
    }

    try {
        const response = await post(
            '/tools/vin/decode',
            { vin },
            {
                Authorization: `Bearer ${localStorage.getItem('h-access_token')}`,
            }
        );

        console.log('VIN decode API response:', response);

        const decodedData = response?.data?.data;
        const apiMessage = response?.data?.message || response?.data?.success || '';

        if (!decodedData) {
            notification.error({
                message: 'VIN Decode Failed',
                description: apiMessage || 'VIN decode API returned no vehicle data.',
            });

            return false;
        }

        const makeName = decodedData.make || '';
        const makes = props?.vehicleMakes?.data || [];

        const matchedMake = makes.find(
            (m) =>
                m &&
                m.name &&
                makeName &&
                m.name.toLowerCase() === makeName.toLowerCase()
        );

        const yearValue = decodedData.model_year
            ? decodedData.model_year.toString()
            : jobItem?.vehicle?.year?.toString();

        const modelValue = decodedData.model || jobItem?.vehicle?.model;
        const makeIdValue = matchedMake ? matchedMake.id : null;
        const makeNameValue = matchedMake ? matchedMake.name : makeName || null;

        const updatedJob = {
            ...jobItem,

            vehicle_vin: vin,
            vehicle_year: yearValue,
            vehicle_model: modelValue,
            vehicle_make_id: makeIdValue,

            vehicle: {
                ...jobItem?.vehicle,

                vin,
                year: yearValue,
                model: modelValue,

                make: {
                    ...jobItem?.vehicle?.make,
                    id: makeIdValue,
                    name: makeNameValue,
                },
            },
        };

        setJobItem(updatedJob);

        if (updatedJob?.id) {
            try {
                await props.createNewJob(updatedJob, 1);

                notification.success({
                    message: 'VIN Decode Successful',
                    description: apiMessage || 'Vehicle details have been auto-filled and saved.',
                });
            } catch (saveError) {
                console.error('VIN auto-fill save error:', saveError);

                notification.error({
                    message: 'VIN Save Failed',
                    description: 'Vehicle data was decoded but failed to save to the job. Please try again.',
                });

                return false;
            }
        } else {
            notification.success({
                message: 'VIN Decode Successful',
                description: 'Vehicle details have been auto-filled in the form.',
            });
        }

        return true;
    } catch (error) {
        console.error('VIN scan error:', error);

        notification.error({
            message: 'VIN Scan Error',
            description:
                error?.response?.data?.message ||
                'There was a problem scanning the VIN or decoding the data.',
        });

        return false;
    } finally {
        setIsScanningVin(false);

        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    }
};

const CustomInput = forwardRef(
    ({ value, onClick, label }, ref) => (
        <div onClick={onClick} ref={ref} className='item d-flex align-items-center justify-content-end gap-1' >
            <span className='item_label'>{label}:</span>
            <span className='item_date'>{value ? dateFormat(value, 'INOUT_DATE') : 'Not set'}</span>
        </div>
    ),
);

    const changeInOutDate = (date, type) => {
        setAlertShow(true)
        setAlertLoading(true)
        switch(type) {
            case "IN":
                setJobInDate(date);
                break;
            case "OUT":
                setJobOutDate(date);
                break;
        }

        const token = localStorage.getItem('h-access_token')
    
        post('/jobs/updateDate/' + jobItem.id, {date:moment( date).format("YYYY-MM-DD"), type: type}, {
            "Authorization": `Bearer ` + token
        }).then(result => {
            setAlertLoading(false)
            setIsSuccess(true)
        }).catch(e => {
            setAlertLoading(false)
            setISError(true)
            setErrorMsg("Failed to set, please try again later.")
        })
    }

    const onArchive = () => {
        const token = localStorage.getItem('h-access_token')

        setArchiveOpen(true);

        get(`/jobs/${jobItem?.id}/${!jobArchiveAt ? 'archived' : 'unarchived'}`, {
            "Authorization": `Bearer ` + token
        }).then(result => {
            if(result) {
                notification.open({
                    type: 'success',
                    message: 'Alert!',
                    description: `Job successfully ${!jobArchiveAt ? 'archived' : 'unarchived'}`,
                    onClick: () => {
                    },
                });

                switch (result?.type) {
                    case 1:
                        setJobArchiveAt(result?.date)
                        props.onArchiveJob(0); // 0: archive, 1: unarchive
                        break;
                    case 2:
                        props.onArchiveJob(1); // 0: archive, 1: unarchive
                        setJobArchiveAt(null)
                        break;
                }

                handleCloseArchiveModal()
            }
        }).catch(e => {
            notification.open({
                type: 'warning',
                message: 'Alert!',
                description: 'Failed to set, please try again later;',
                onClick: () => {
                },
            });
        });
    }

    const resetAllNoteState = () => {
        setReset(true)
        setShowEditor(false)
        setShowSendCustomerBtn(false)
        setComment('')
        setPlainComment("")
        setAttachments([])
    }

    const onAddNote = (sendToCustomer = false) => {
        if (!comment)
            return

        setLoading(true)
        const payload = {
            job_id: props.item.id,
            message: comment,
            file_ids: JSON.stringify(attachments?.map((file) => file?.id)),
            send_to_customer: sendToCustomer,
            sent_or_received: sendToCustomer ? "sent" : "saved",
            sender_id: props?.user?.data?.id
        }

        const token = localStorage.getItem('h-access_token')

        post('/notes', payload, {
            "Authorization": `Bearer ` + token
        }).then(result => {
            if (result.status === 201) {
                setSaved(true)
                if (result?.data?.message) {
                    openNotification("success", result?.data?.message)
                }
                resetAllNoteState()
                setTimeout(() => {
                    setSaved(false)
                }, 20000)
            } else {
                openNotification("warning", result?.data?.message)
            }
            setLoading(false)
        }).catch(e => {
            console.log(e, e?.response)
            setLoading(false)
            openNotification("error", e?.response?.data?.message ?? 'Failed to create note')
            return e
        })
    }

    const openNotification = (type, message) => {
        notification.open({
            type: type,
            message: `${type.charAt(0).toUpperCase()}${type.slice(1)}`,
            description: message,
            duration: 0,
        });
    }

    const createJob = (data) => {
        setCustomer(data)
        setJobItem((prev) => {
            const newData = { ...prev, customer: data }
            return newData
        })
        let createData = {
            customer_id: data.id,
            ...jobItem
        };
        const isFirstJob = production_count === 0 && planning_count === 0
        props.createNewJob(createData, 0, isFirstJob)
        props.debouncedGetCustomers()
    }

    const onCustomerSearch = (search) => {
        setSearch(search)
        if(search.length >= 3 ){
            const query = `?search=${search}`
            props.debouncedGetCustomers(query)
        }
        else if (search.length === 0)
            setCustomers([])
    }

    const onSwitchChange = async (checked) => {
        const nextValue = !!checked
        setShowDetail(nextValue)
        localStorage.setItem('showDetail', String(nextValue))
        props.getNoteList(props.item.id, checked)
    }


    const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step));
    const customerEmail = jobItem?.customer?.email ?? '';
    const isInvalidCustomerEmail = !customerEmail || customerEmail.toLowerCase().endsWith('.invalid');

    return (
        <>
            <Spin spinning={props.newJob.isCreating ?? false} key={isNewJob} >
            
            <div className='expandcard-header'>
                {isAlertShow &&
                    <ApiSpin loading={isAlertLoading} error={isError} success={isSuccess} error_txt={errorMsg} support_url={SUPPORT_URL} />
                }
                <div className={`edit-number ${jobArchiveAt ? 'archived' : ''}`} onClick={() => setFocusField('ro_number')} onBlur={() => setFocusField('')}>
                    <div className='card-id'>
                            {!isNewJob && <span>#</span>}
                        {
                            !jobArchiveAt?
                            <Editable
                                type='text'
                                defaultValue={jobItem?.ro_number ?? ''}
                                onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'ro_number', '', jobItem?.ro_number ?? '')}
                                onBlur = {(e) => focusOutOnEnter(e.type, e.target.value, 'ro_number', '', jobItem?.ro_number ?? '')}
                                focusField={focusField === 'ro_number' || isNewJob}
                                autoFocus={true}
                                tabIndex={1}
                                placeholder='#'
                            />
                            :
                            <span>{jobItem?.ro_number}</span>
                        }
                    </div>
                    <img alt="" src={require('../../assets/images/pencil-blue.svg').default} />
                </div>
                <div className='in-out_dates d-flex align-items-center justify-content-between gap-1'>
                    {
                        canSetInOutDate && !jobArchiveAt &&
                        <>
                            <DatePicker
                                selected={jobInDate ? new Date(jobInDate) : null}
                                minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
                                maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 2))}
                                onChange={(date) => changeInOutDate(date, "IN")}
                                customInput={<CustomInput className="custom-input" label="IN" />}
                                withPortal
                            />
                            <DatePicker
                                selected={jobOutDate ? new Date(jobOutDate) : null}
                                minDate={jobInDate ? new Date(jobInDate) : new Date(new Date().getFullYear() - 1, 0, 1)}
                                maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 2))}
                                onChange={(date) => changeInOutDate(date, "OUT")}
                                customInput={<CustomInput className="custom-input" label="OUT" />}
                                withPortal
                            />
                        </>
                        }
                        { canUpdateJobArchive && !isNewJob &&
                            <div className='archive_btn d-flex align-items-center'>
                                <svg onClick={() => setArchiveOpen(true)} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m7 11.609 3.009-3.01-.868-.867-1.523 1.523V5.591H6.382v3.664L4.86 7.732l-.87.868zM1.235 3.626v8.884q0 .111.072.183a.25.25 0 0 0 .182.07H12.51a.25.25 0 0 0 .183-.07.25.25 0 0 0 .07-.183V3.627zM1.552 14q-.615 0-1.084-.468Q0 13.064 0 12.448v-9.56q0-.265.085-.505.084-.24.254-.443L1.495.542q.203-.265.507-.403.304-.14.643-.139h8.694q.34 0 .647.139.309.138.511.403l1.164 1.414q.17.203.254.446.085.245.085.509v9.537q0 .616-.468 1.084T12.448 14zm.005-11.608h10.878l-.898-1.07a.3.3 0 0 0-.09-.063.3.3 0 0 0-.108-.024H2.653a.3.3 0 0 0-.107.024.3.3 0 0 0-.091.063z" fillOpacity=".7" />
                                    </svg>
                                {
                                    archiveOpen &&
                                    (
                                        !jobArchiveAt ?
                                            <div className='archive_modal'>
                                                <h4>Archive this job?</h4>
                                                <div className='btn-group'>
                                                    <button className='archive_yes' onClick={() => onArchive()}>
                                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m7 11.609 3.009-3.01-.868-.867-1.523 1.523V5.591H6.382v3.664L4.86 7.732l-.87.868zM1.235 3.626v8.884q0 .111.072.183a.25.25 0 0 0 .182.07H12.51a.25.25 0 0 0 .183-.07.25.25 0 0 0 .07-.183V3.627zM1.552 14q-.615 0-1.084-.468Q0 13.064 0 12.448v-9.56q0-.265.085-.505.084-.24.254-.443L1.495.542q.203-.265.507-.403.304-.14.643-.139h8.694q.34 0 .647.139.309.138.511.403l1.164 1.414q.17.203.254.446.085.245.085.509v9.537q0 .616-.468 1.084T12.448 14zm.005-11.608h10.878l-.898-1.07a.3.3 0 0 0-.09-.063.3.3 0 0 0-.108-.024H2.653a.3.3 0 0 0-.107.024.3.3 0 0 0-.091.063z" fill="#fff" /></svg>
                                                        <span>YES</span>
                                                    </button>
                                                    <button onClick={() => handleCloseArchiveModal()} className='archive_no'>NO</button>
                                                </div>
                                                <div className='description'>
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0 10C0 4.477 4.476 0 10 0c5.523 0 10 4.476 10 10 0 5.523-4.476 10-10 10-5.523 0-10-4.476-10-10m11-.863q0-.54-.381-.843-.38-.303-.967-.302-.585 0-.952.302-.367.303-.367.902v5.77q0 .59.367.908.366.318.952.318.585 0 .967-.31.381-.311.381-.917zM9.681 6.324q.538 0 .928-.397T11 4.823q0-.728-.4-1.109a1.3 1.3 0 0 0-.919-.38q-.537 0-.942.42t-.406 1.07q0 .716.396 1.108t.952.392" fill="#959393" /></svg>
                                                    <span>You can always find it by going to the Jobs &gt; List page in the main menu.</span>
                                                </div>
                                            </div>
                                            :
                                            <div className='archive_modal'>
                                                <div onClick={() => onArchive()} className='unarchive_wrap d-flex gap-3 align-items-center justify-content-start'>
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m9 7.289-3.654 3.653L6.4 11.996l1.85-1.85v4.45h1.5v-4.45l1.85 1.85 1.054-1.054zM2 4.904v10.788a.3.3 0 0 0 .087.222.3.3 0 0 0 .22.086h13.385a.3.3 0 0 0 .222-.086.3.3 0 0 0 .086-.222V4.904zM2.385 17.5q-.75 0-1.317-.568Q.5 16.362.5 15.615V4.005q0-.32.103-.612.103-.291.309-.537l1.404-1.698q.245-.321.615-.49Q3.3.5 3.71.5h10.56q.412 0 .786.168t.62.49l1.413 1.717q.206.246.309.542t.103.618v11.58q0 .75-.568 1.317-.57.568-1.317.568zM2.39 3.404H15.6l-1.09-1.298a.4.4 0 0 0-.111-.077.3.3 0 0 0-.13-.029H3.721a.3.3 0 0 0-.13.029.4.4 0 0 0-.11.077z" fill="#73D19D" /></svg>
                                                    <span>Unarchive</span>
                                                </div>
                                                <svg onClick={() => handleCloseArchiveModal()} className='close' width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M8.25 1.41 7.59.75 4.5 3.828 1.41.75l-.66.66L3.828 4.5.75 7.59l.66.66L4.5 5.172 7.59 8.25l.66-.66L5.172 4.5z" fill="#3F3B3B" /></svg>
                                            </div>
                                    )
                                }
                            </div>
                        }
                </div>
            </div>
            <div className='section' >
                <div className="d-flex flex-column jobdetail justify-content-between">
                    <div className='customer-details'>
                            <div className="info-row">
                            
                                    <div className='add-customer-row'>
                                    { canSeeJobCustomerName && isNewJob && !jobItem?.customer &&
                                        <>
                                            <div className="flex-grow-1">
                                                <ReactSelect
                                                    onChange={(option) => createJob(option)}
                                                    onInputChange={(value)=> onCustomerSearch(value) }
                                                    options={customers}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    styles={customStyles}
                                                    name="customer"
                                                    className="select-box-bottom-line"
                                                    value={customer}
                                                    placeholder="Search for..."
                                                    autoComplete="vin"
                                                    filterOption={() => true}
                                                    noOptionsMessage={() => (props.customers.loading ? 'Loading...' : search.length >=3 && !props.customers.loading ? 'No results found' : '')}
                                                    getOptionLabel={e => (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img src={e.icon_url} alt="" className="mr-2" />
                                                            <span style={{ marginLeft: 5 }}>{(e.firstname && e.lastname) ? e.firstname + " " + e.lastname : ''}</span>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                            <span className='label-or'>OR</span>
                                        </>
                                    }
                                    <Customer customerData={jobItem?.customer}>
                                        {isNewJob && !jobItem?.customer ?
                                            <FilledBrightButton
                                                svgFile={plus}
                                                title="New Customer"
                                                clickEvent={(e) => { }}
                                            />
                                            :
                                            <div className="edit-info">
                                                <b className='main-font-bold'>{jobItem.customer ? `${jobItem.customer.firstname} ${jobItem.customer.lastname}` : ''}</b>
                                                <img alt="" src={require('../../assets/images/pencil-blue.svg').default} />
                                            </div>
                                        }
                                    </Customer>
                                </div>
                                {jobItem?.customer &&
                                    <div className="edit-info d-flex flex-row">
                                        <span className='d-sm-none'>{jobItem?.customer?.address ?? '-'}</span>
                                        <div>
                                            <a href={`tel:${jobItem?.customer?.helios_user_setting?.phone_number}`} className='d-flex align-items-center'>
                                                {jobItem?.customer?.helios_user_setting?.phone_number && <img className='phone-svg d-flex' alt="" src={require('../../assets/images/phone.svg').default} />}
                                                {jobItem?.customer?.helios_user_setting?.phone_number && <span>{formatPhoneNumber(jobItem?.customer?.helios_user_setting?.phone_number)}</span>}
                                            </a>
                                            {jobItem?.customer?.helios_user_setting?.alternate_phone &&
                                                <a href={`tel:${jobItem?.customer?.helios_user_setting?.alternate_phone}`} className='d-flex align-items-center'>
                                                    {jobItem?.customer?.helios_user_setting?.alternate_phone && <img className='phone-svg d-flex' alt="" src={require('../../assets/images/phone.svg').default} />}
                                                    {jobItem?.customer?.helios_user_setting?.alternate_phone && <span>{formatPhoneNumber(jobItem?.customer?.helios_user_setting?.alternate_phone)}</span>}
                                                </a>
                                            }
                                        </div>
                                    </div>
                                }
                        </div>
                        <div className="info-row d-none d-sm-flex">
                            <span>Address</span>
                            <div className="edit-info">
                                <span className='border-0'>{jobItem?.customer?.address ?? '-'}</span>
                            </div>
                        </div>
                        <div className="info-row">
                            <span className='info-label'>VIN</span>
                            <div className="edit-info" onClick={() => setFocusField('vin')} onFocus={() => setFocusField('vin')}>
                                {
                                    !jobArchiveAt ?
                                    <>
                                        <img alt="" src={require('../../assets/images/pencil-blue.svg').default} />
                                        <Editable
                                            type='text'
                                            defaultValue={jobItem?.vehicle?.vin}
                                            focusField={focusField === 'vin' || isNewJob}
                                            size={240}
                                            maxLength={17}
                                            onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'vehicle_vin', 'vehicle.vin', jobItem?.vehicle?.vin ?? '')}
                                            onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'vehicle_vin', 'vehicle.vin', jobItem?.vehicle?.vin ?? '')}
                                            autoFocus={true}
                                            tabIndex={9}
                                            placeholder='Type your VIN'
                                        />
                                        

                                        <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8 }}>
                                            <svg
                                                width="38"
                                                height="38"
                                                viewBox="0 0 38 38"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className={`scan-vin-button ${isScanningVin ? 'disabled' : ''}`}
                                                style={{ cursor: isScanningVin ? 'not-allowed' : 'pointer', opacity: isScanningVin ? 0.5 : 1, verticalAlign: 'middle', outline: 'none', boxShadow: 'none', border: 'none' }}
                                                onClick={() => !isScanningVin && setShowVinScanner(true)}
                                                role="button"
                                                tabIndex={0}
                                                aria-label={isScanningVin ? 'Scanning VIN' : 'Open VIN scanner'}
                                                aria-disabled={isScanningVin}
                                                onKeyDown={(e) => {
                                                    if (!isScanningVin && (e.key === 'Enter' || e.key === ' ')) {
                                                        setShowVinScanner(true)
                                                    }
                                                }}
                                            >
                                            <g filter="url(#filter1_dd_5068_47932)">
                                                <circle cx="19" cy="17" r="14.5" fill="#1658AC" stroke="#F2F7FE" />
                                                <path d="M25.5882 23H12.4118C11.6118 23 11 22.3943 11 21.6022V13.2151C11 12.4229 11.6118 11.8172 12.4118 11.8172H15.2353C15.3294 11.8172 15.4706 11.724 15.5176 11.6774L16.0353 10.6523C16.2235 10.2796 16.6941 10 17.1176 10H20.8824C21.3059 10 21.7765 10.2796 21.9647 10.6523L22.4824 11.6774C22.5294 11.7706 22.6706 11.8172 22.7647 11.8172H25.5882C26.3882 11.8172 27 12.4229 27 13.2151V21.6022C27 22.3943 26.3882 23 25.5882 23V23ZM12.4118 12.7491C12.1294 12.7491 11.9412 12.9355 11.9412 13.2151V21.6022C11.9412 21.8817 12.1294 22.0681 12.4118 22.0681H25.5882C25.8706 22.0681 26.0588 21.8817 26.0588 21.6022V13.2151C26.0588 12.9355 25.8706 12.7491 25.5882 12.7491H22.7647C22.3412 12.7491 21.8706 12.4695 21.6824 12.0968L21.1647 11.0717C21.1176 10.9785 20.9765 10.8853 20.8824 10.8853H17.1176C17.0235 10.8853 16.8824 10.9785 16.8353 11.0251L16.3176 12.0502C16.1294 12.4695 15.6588 12.7491 15.2353 12.7491H12.4118V12.7491Z" fill="white" />
                                                <path d="M18.9999 21.1361C16.647 21.1361 14.7646 19.2723 14.7646 16.9426C14.7646 14.6128 16.647 12.749 18.9999 12.749C21.3529 12.749 23.2352 14.6128 23.2352 16.9426C23.2352 19.2723 21.3529 21.1361 18.9999 21.1361ZM18.9999 13.6809C17.1646 13.6809 15.7058 15.1254 15.7058 16.9426C15.7058 18.7598 17.1646 20.2042 18.9999 20.2042C20.8352 20.2042 22.2941 18.7598 22.2941 16.9426C22.2941 15.1254 20.8352 13.6809 18.9999 13.6809Z" fill="white" />
                                                <path d="M23.7059 14.1467C23.9658 14.1467 24.1765 13.9381 24.1765 13.6808C24.1765 13.4235 23.9658 13.2148 23.7059 13.2148C23.446 13.2148 23.2354 13.4235 23.2354 13.6808C23.2354 13.9381 23.446 14.1467 23.7059 14.1467Z" fill="white" />
                                                <path d="M12.8823 10.8853H14.7647V11.3512H12.8823V10.8853ZM19 15.0788V14.6129C17.6823 14.6129 16.647 15.6379 16.647 16.9426H17.1176C17.1176 15.9175 17.9647 15.0788 19 15.0788Z" fill="white" />
                                            </g>
                                            <defs>
                                                <filter id="filter1_dd_5068_47932" x="0" y="0" width="38" height="38" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                    <feOffset dy="2" />
                                                    <feGaussianBlur stdDeviation="2" />
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5068_47932" />
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                    <feOffset />
                                                    <feGaussianBlur stdDeviation="0.5" />
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0" />
                                                    <feBlend mode="normal" in2="effect1_dropShadow_5068_47932" result="effect2_dropShadow_5068_47932" />
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5068_47932" result="shape" />
                                                </filter>
                                            </defs>
                                            </svg>

                                            {isScanningVin && <Spin size={'small'} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                                        </span>

                                        {showVinScanner && (
                                            <VinSmartScanner
                                                barcodeOnly={true}
                                                onClose={() => setShowVinScanner(false)}
                                                onBarcodeDetected={handleVinBarcodeDetected}
                                                onVinBoxCaptured={handleVinBoxCaptured}
                                            />
                                        )}
                                        
                                    </>
                                    :
                                    <span>{jobItem?.vehicle?.vin}</span>
                                }
                            </div>
                        </div>
                        <div className="info-row">
                            <span className='info-label' >Year / Make / Model</span>
                            <div className="edit-info mobile-edit-info" >
                                {
                                    !jobArchiveAt &&
                                    <img alt="" src={require('../../assets/images/pencil-blue.svg').default} />
                                }
                                <div className='edit-content'>
                                    <div onClick={() => setFocusField('vehicle_year')} onFocus={() => setFocusField('vehicle_year')}>
                                        {
                                            !jobArchiveAt ?
                                            <Editable
                                                type='select'
                                                defaultValue={jobItem?.vehicle?.year}
                                                onChange={(e) => {
                                                    setJobItem((prev) => ({
                                                        ...prev,
                                                        vehicle_year: e,
                                                        vehicle: {
                                                            ...prev?.vehicle,
                                                            year: e
                                                        }
                                                    }))
                                                    if (jobItem?.id) {
                                                        setChanged(true)
                                                        setAlertShow(true)
                                                    }
                                                }}
                                                focusField={focusField === 'vehicle_model' || focusField === 'vehicle_make_id' || focusField === 'vehicle_year' || isNewJob}
                                                options={years.map((i) => { return { value: i?.toString(), label: i?.toString() } })}
                                                tabIndex={2}
                                                size={80}
                                                placeholder='Year'
                                                autoFocus={focusField === 'vehicle_year'}
                                            />
                                            :
                                            <span>{jobItem?.vehicle?.year}</span>
                                        }
                                    </div>

                                    <div onClick={() => setFocusField('vehicle_make_id')} onFocus={() => setFocusField('vehicle_make_id')}>
                                        {
                                            !jobArchiveAt ?
                                            <Editable
                                                type='select'
                                                defaultValue={jobItem?.vehicle?.make?.name}
                                                onChange={(e) => {
                                                    setJobItem((prev) => ({
                                                        ...jobItem,
                                                        vehicle_make_id: e,
                                                        vehicle: {
                                                            ...prev?.vehicle,
                                                            make: {
                                                                ...prev?.vehicle?.make,
                                                                name: Object.keys(props?.vehicleMakes?.data)?.length > 0 ? props?.vehicleMakes?.data?.find((data) => data?.id === e)?.name : ''
                                                            }
                                                        }
                                                    }))
                                                    if (jobItem?.id) {
                                                        setChanged(true)
                                                        setAlertShow(true)
                                                    }
                                                }}
                                                focusField={focusField === 'vehicle_model' || focusField === 'vehicle_make_id' || focusField === 'vehicle_year' || isNewJob}
                                                options={props?.vehicleMakes?.data && Object.keys(props?.vehicleMakes?.data)?.length > 0 ? props?.vehicleMakes?.data?.map((i) => { return { value: i.id, label: i.name } }) : []}
                                                tabIndex={3}
                                                size={130}
                                                placeholder='Make'
                                            />
                                            :
                                            <span>{jobItem?.vehicle?.make?.name}</span>
                                        }
                                    </div>

                                    <div className='model-field' onClick={() => setFocusField('vehicle_model')} onFocus={() => setFocusField('vehicle_model')}>
                                        {
                                            !jobArchiveAt ?
                                            <Editable
                                                type='text'
                                                defaultValue={jobItem?.vehicle?.model}
                                                focusField={focusField === 'vehicle_model' || focusField === 'vehicle_make_id' || focusField === 'vehicle_year' || isNewJob}
                                                autoFocus={focusField === 'vehicle_model'}
                                                size={60}
                                                onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'vehicle_model', 'vehicle.model', jobItem?.vehicle?.model ?? '')}
                                                onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'vehicle_model', 'vehicle.model', jobItem?.vehicle?.model ?? '')}
                                                tabIndex={4}
                                                placeholder='Model'
                                            />
                                            :
                                            <span>{jobItem?.vehicle?.model}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="info-row">
                            <span className='info-label'>Insurance Company</span>
                            <div className="edit-info" onClick={() => setFocusField('insurance_company')} onFocus={() => setFocusField('insurance_company')}>
                                {
                                    !jobArchiveAt ?
                                    <>
                                        <img alt="" src={require('../../assets/images/pencil-blue.svg').default} />
                                        <Editable
                                            type='text'
                                            defaultValue={jobItem?.insurance_company}
                                            focusField={focusField === 'insurance_company' || isNewJob}
                                            onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'insurance_company', '', jobItem?.insurance_company ?? '')}
                                            onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'insurance_company', '', jobItem?.insurance_company ?? '')}
                                            autoFocus={true}
                                            tabIndex={5}
                                            size={180}
                                            placeholder='Type your Insurance company'
                                        />
                                    </>
                                    :
                                    <span>{jobItem?.insurance_company}</span>
                                }
                            </div>
                        </div>
                        <div className="info-row">
                            <span className='info-label'>Color / Paint Code</span>
                            <div className="edit-info" >
                                {
                                    !jobArchiveAt ?
                                    <>
                                        <img alt="" src={require('../../assets/images/pencil-blue.svg').default} />
                                        <div className='edit-content'>
                                            <div onClick={() => setFocusField('color')} onFocus={() => setFocusField('color')}>
                                                <Editable
                                                    type='text'
                                                    defaultValue={jobItem?.vehicle?.exterior_color}
                                                    focusField={focusField === 'color' || focusField === 'paint_code' || isNewJob}
                                                    autoFocus={focusField === 'color'}
                                                    onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'vehicle_exterior_color', 'vehicle.exterior_color', jobItem?.vehicle?.exterior_color ?? '')}
                                                    onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'vehicle_exterior_color', 'vehicle.exterior_color', jobItem?.vehicle?.exterior_color ?? '')}
                                                    tabIndex={6}
                                                    placeholder='xxxxxxx'
                                                />
                                            </div>
                                            <span>{'/'}</span>
                                            <div onClick={() => setFocusField('paint_code')} onFocus={() => setFocusField('paint_code')}>
                                                <Editable
                                                    type='text'
                                                    defaultValue={jobItem?.vehicle?.paint_code}
                                                    focusField={focusField === 'color' || focusField === 'paint_code' || isNewJob}
                                                    autoFocus={focusField === 'paint_code'}
                                                    onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'vehicle_paint_code', 'vehicle.paint_code', jobItem?.vehicle?.paint_code ?? '')}
                                                    onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'vehicle_paint_code', 'vehicle.paint_code', jobItem?.vehicle?.paint_code ?? '')}  
                                                    tabIndex={7}
                                                    placeholder='000 /0000'
                                                />
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <span>{jobItem?.vehicle?.exterior_color}</span>
                                        <span>{'/'}</span>
                                        <span>{jobItem?.vehicle?.paint_code}</span>
                                    </>
                                }
                            </div>
                        </div>
                        <div className="info-row">
                            <span className='info-label'>License Plate</span>
                            <div className="edit-info" onClick={() => setFocusField('license')} onFocus={() => setFocusField('license')}>
                                {
                                    !jobArchiveAt ?
                                    <>
                                        <img alt="" src={require('../../assets/images/pencil-blue.svg').default} />
                                        <Editable
                                            type='text'
                                            defaultValue={jobItem?.vehicle?.license_plate_number}
                                            focusField={focusField === 'license' || isNewJob}
                                            size={90}
                                            maxLength={10}
                                            onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'vehicle_license_plate_number', 'vehicle.license_plate_number', jobItem?.vehicle?.license_plate_number ?? '')}
                                            onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'vehicle_license_plate_number', 'vehicle.license_plate_number', jobItem?.vehicle?.license_plate_number ?? '')}
                                            autoFocus={true}
                                            tabIndex={8}
                                            placeholder='Type your licence plate'
                                        />
                                    </>
                                    :
                                    <span>{jobItem?.vehicle?.license_plate_number}</span>
                                }
                            </div>
                        </div>
                        {/* Vin was here... and now move to top for autofill down fields */}
                        <div className="info-row">
                            <span className='info-label'>Trim Code</span>
                            <div className="edit-info" onClick={() => setFocusField('trim')} onFocus={() => setFocusField('trim')}>
                                {
                                    !jobArchiveAt ?
                                    <>
                                        <img alt="" src={require('../../assets/images/pencil-blue.svg').default} />
                                        <Editable
                                            type='text'
                                            defaultValue={jobItem?.vehicle?.trim_code}
                                            focusField={focusField === 'trim' || isNewJob}
                                            onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'vehicle_trim_code', 'vehicle.trim_code', jobItem?.vehicle?.trim_code ?? '')}
                                            onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'vehicle_trim_code', 'vehicle.trim_code', jobItem?.vehicle?.trim_code ?? '')}
                                            autoFocus={true}
                                            tabIndex={10}
                                            placeholder='Type your Trim code'
                                        />
                                    </>
                                    :
                                    <span>{jobItem?.vehicle?.trim_code}</span>
                                }
                            </div>
                        </div>
                        <div className="info-row">
                            <span className='info-label'>Frame Hours / Paint Hours</span>
                            <div className="edit-info">
                                {
                                    !jobArchiveAt ?
                                    <>
                                        <img alt="" src={require('../../assets/images/pencil-blue.svg').default} />
                                        <div className='edit-content'>
                                            <div onClick={() => setFocusField('frame_hours')} onFocus={() => setFocusField('frame_hours')} >
                                                <Editable
                                                    type='text'
                                                    defaultValue={isNewJob ? '' : jobItem?.frame_hours !== null ? formatHours(jobItem?.frame_hours, '') : ''}
                                                    focusField={focusField === 'frame_hours' || focusField === 'paint_hours' || isNewJob}
                                                    size={35}
                                                    onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'frame_hours', '', jobItem?.frame_hours ?? '')}
                                                    onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'frame_hours', '', jobItem?.frame_hours ?? '')}
                                                    autoFocus={focusField === 'frame_hours'}
                                                    tabIndex={11}
                                                    postFix='h'
                                                    placeholder='00h'
                                                />
                                            </div>
                                            <span>{'/'}</span>
                                            <div onClick={() => setFocusField('paint_hours')} onFocus={() => setFocusField('paint_hours')}>
                                                <Editable
                                                    type='text'
                                                    defaultValue={isNewJob ? '' : jobItem?.paint_hours !== null ? formatHours(jobItem?.paint_hours, '') : ''}
                                                    focusField={focusField === 'frame_hours' || focusField === 'paint_hours' || isNewJob}
                                                    size={35}
                                                    onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'paint_hours', '', jobItem?.paint_hours ?? '')}
                                                    onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'paint_hours', '', jobItem?.paint_hours ?? '')}
                                                    autoFocus={focusField === 'paint_hours'}
                                                    tabIndex={12}
                                                    postFix='h'
                                                    placeholder='00h'
                                                />
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <span>{jobItem?.frame_hours !== null ? formatHours(jobItem?.frame_hours, '') : ''}</span>
                                        <span>{'/'}</span>
                                        <span>{jobItem?.paint_hours !== null ? formatHours(jobItem?.paint_hours, '') : ''}</span>
                                    </>
                                }
                            </div>
                        </div>
                        <div className="info-row">
                            <span className='info-label'>Job value</span>
                            <div className="edit-info" onClick={() => setFocusField('job_value')} onFocus={() => setFocusField('job_value')}>
                                {
                                   canSeeJobValue && !jobArchiveAt ?
                                    <>
                                        <img alt="" src={require('../../assets/images/pencil-blue.svg').default} />
                                        <Editable
                                            type='value'
                                            defaultValue={isNewJob ? '' : jobItem?.value !== null ? formatNumber(jobItem?.value, 2, '') : ''}
                                            focusField={focusField === 'job_value' || isNewJob}
                                            onKeyDown={(e) => focusOutOnEnter(e.code, jobValue, 'value', '', jobItem?.value ?? '')}
                                            onChange={(e) => setJobValue(e.floatValue)}
                                            onBlur = {(e) => focusOutOnEnter(e.type, jobValue, 'value', '', jobItem?.value ?? '')}
                                            autoFocus={focusField === 'job_value'}
                                            tabIndex={13}
                                            preFix='$'
                                            size={'50%'}
                                        />
                                    </>
                                    :
                                    <span>{jobItem?.value !== null ? formatNumber(jobItem?.value, 2, '') : ''}</span>
                                }
                            </div>
                        </div>
                    </div>
                    <Modal
                        className="note_modal"
                        centered
                        open={noteOpen}
                        onCancel={() => {
                            setNoteOpen(false)
                            props.replyBack(false)
                        }}
                        footer={null}
                        header={null}
                    >
                        <div className="note_wrap">
                            <div className="note_header">
                                <span>FROM</span>
                                <span>METHOD</span>
                                <span>MESSAGE</span>
                                <span>DATE</span>
                            </div>
                            <div className="note_content">
                                <span>{singleNote?.sender?.firstname}</span>
                                <span><img src={require('../../assets/images/sms-down.png').default} /></span>
                                <span>{singleNote?.message}</span>
                                <span>{dateFormat(singleNote?.created_at, 'TXT_YEAR_DATE')}</span>
                            </div>
                            <div className="note_footer">
                                <div>
                                    <div onClick={() => onMoveNote(currentNoteIndex == (props?.notes?.length - 1) ? currentNoteIndex : currentNoteIndex + 1)} className="note_previus">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M13.178 6.278H2.846L5.95 9.172a.752.752 0 0 1 .245.55.752.752 0 0 1-.245.55.865.865 0 0 1-.59.228.865.865 0 0 1-.589-.228L.244 6.05a.742.742 0 0 1 0-1.1L4.77.728A.862.862 0 0 1 5.36.5c.214 0 .427.076.59.228a.752.752 0 0 1 .244.55.752.752 0 0 1-.244.55L2.846 4.722h10.332c.456.007.822.353.822.778 0 .425-.366.772-.822.778Z" fill={currentNoteIndex < (props?.notes?.length - 1) ? "#0051BA" : "#EAEAEA"} fillOpacity=".7" /></svg>
                                        <span className={currentNoteIndex < (props?.notes?.length - 1) ? "" : "disabled"}>Previous</span>
                                    </div>
                                    <div className="note_reply" onClick={() => props.replyBack(true, currentNoteIndex, props?.notes[currentNoteIndex])}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none"><path d="M12.765 10.5V7.84c0-.683-.262-1.265-.784-1.748-.523-.482-1.154-.724-1.893-.724H2.366l3.17 2.927-.88.801L0 4.798 4.656.5l.88.801-3.17 2.927h7.722c1.081 0 2.004.352 2.767 1.057C13.618 5.99 14 6.841 14 7.84v2.66h-1.235Z" fill="#5D6F88" /></svg>
                                        <span>Reply</span>
                                    </div>
                                </div>
                                <div>
                                    <div onClick={() => onMoveNote(currentNoteIndex == 0 ? 0 : currentNoteIndex - 1)} className="note_next-message">
                                        <span className={currentNoteIndex == 0 ? "disabled" : ""}>Next message</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M.821 6.278h10.333L8.05 9.172a.752.752 0 0 0-.245.55.75.75 0 0 0 .245.55.865.865 0 0 0 .59.228.865.865 0 0 0 .589-.228l4.526-4.222a.742.742 0 0 0 0-1.1L9.23.728A.862.862 0 0 0 8.64.5a.861.861 0 0 0-.59.228.752.752 0 0 0-.244.55c0 .206.088.404.244.55l3.104 2.894H.82C.366 4.73 0 5.075 0 5.5c0 .425.366.772.821.778Z" fill={currentNoteIndex == 0 ? "#EAEAEA" : "#0051BA"} fillOpacity=".7" /></svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {replyNoteOpen &&
                        <Modal
                            className="note-modal"
                            open={replyNoteOpen}
                            footer={null}
                            width={492}
                            onOk={() => { }}
                            onCancel={() => { }}
                            closeIcon={
                                <img
                                    className="modal-close"
                                    alt=""
                                    src={require("../../assets/images/production_board/modal-close.svg").default}
                                />
                            }
                            centered
                        >
                            <AddNodes currentUser={props.currentUser} jobItem={jobItem} jobId={jobItem.id} />
                        </Modal>
                    }
                </div>
                <PhotoManagement
                    currentNoteIndex={props.currentNoteIndex}
                    currentNote={props.currentNote}
                    currentUser={props.currentUser}
                    item={props.item}
                    jobArchiveAt={jobArchiveAt}
                    setAttachments={setAttachments}
                    setShowEditor={setShowEditor}
                    isReset={isReset}
                    setReset={setReset}
                    canAddFile={canAddFile}
                    canDeleteFile={canDeleteFile}
                />
                <div className='section-action'>
                    {canUpdateJobStatus && (
                        <div className="section-item">
                            <label>Status:</label>
                            {
                                !jobArchiveAt ?
                                <AutoSelectOnTab
                                    tabIndex={14}
                                    placeholder="Select status"
                                    value={ jobItem?.status_id?.toString() }
                                    size='large'
                                    style={{ width: '100%' }}
                                    onChange={(item) => {
                                        setJobItem({ ...jobItem, status_id: item })
                                        if (jobItem?.id) {
                                            setChanged(true)
                                            setAlertShow(true)
                                        }
                                    }}
                                    handleTabPress={(item) => {
                                        setJobItem({ ...jobItem, status_id: item })
                                        if (jobItem?.id) {
                                            setChanged(true)
                                            setAlertShow(true)
                                        }
                                    }}
                                    options={Object.values(props.jobStatuses.data).map((i) => { return { label: i.name, value: i?.id } })}
                                />
                                :
                                <span>Archived</span>
                            }
                        </div>
                    )}

                    {canAssignCustomer && (
                        <div className="section-item">
                            <label>Assigned to:</label>
                            {
                               !jobArchiveAt ?
                                <AutoSelectOnTab
                                    tabIndex={15}
                                    placeholder="Select user"
                                    value={ jobItem?.assigned_to_user_id }
                                    style={{ width: '100%' }}
                                    onChange={(item) => {
                                        setJobItem({ ...jobItem, assigned_to_user_id: item })
                                        if (jobItem?.id) {
                                            setChanged(true)
                                            setAlertShow(true)
                                        }
                                    }}
                                    size='large'
                                    options={assignableUsers.map((i) => { return { label: `${i.firstname} ${i.lastname}`, value: i?.id } })}
                                    handleTabPress={(item) => {
                                        setJobItem({ ...jobItem, assigned_to_user_id: item })
                                        if (jobItem?.id) {
                                            setChanged(true)
                                            setAlertShow(true)
                                        }
                                    }}
                                />
                                :
                                <span>{jobItem?.assigned_to_user?.firstname} {jobItem?.assigned_to_user?.lastname}</span>
                            }
                        </div>
                    )}

                    {canUpdateJobColor && (
                        <div className="section-item">
                            <label>Card color:</label>
                            <div className='d-flex flex-row gap-2 justify-content-between item'>
                                { props.colorList.data.map((item, index) => {
                                    // Check if the current item is the selected color
                                    const isSelected = jobItem?.color_id === item.id;

                                    return (
                                        <div
                                            key={index}
                                            className='colour-card'
                                            style={{
                                                border: `4px solid ${isSelected ? item.color : 'var(--surface-background)'}`
                                            }}
                                            onClick={() => {
                                                if (isSelected) {
                                                    props.changeBackground(null);
                                                    setJobItem({ ...jobItem, color_id: null, color: null });
                                                    setChanged(true);
                                                } else {
                                                    props.changeBackground(item);
                                                    setJobItem({ ...jobItem, color_id: item.id, color: item?.color });
                                                    setChanged(true);
                                                }
                                            }}>
                                            <div className='card-left' style={{ backgroundColor: item?.color }} />
                                            <div className='linegroup'>
                                                <div className='rectangleParent'>
                                                    <div className='frameChild' />
                                                    <div className='frameChild' />
                                                </div>
                                                <div className='rectangleParent'>
                                                    <div className='frameInner' />
                                                    <div className='frameChild' />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                        </div>
                    )}

                    {canUpdateJobDot && (
                        <div className="section-item">
                            <label>dots:</label>
                            <Dots className="item" defaultValue={jobItem?.dots_bits ? Array.from(jobItem.dots_bits) : []} jobData={jobItem} isFilter={false}
                                onChange={(value) => {
                                    setJobItem({ ...jobItem, dots_bits: value })
                                    setAlertShow(false)
                                }}
                            />
                        </div>
                    )}
                </div>
                <div className='activity-section'>
                    <Block
                        title='Activity'
                        isOpen={activityOpen}
                        onToggle={() => {
                            let activityOpenN = !activityOpen
                            localStorage.setItem('activityOpen', activityOpenN)
                            setACtivityOpen(activityOpenN)
                        }}
                        rightContent={
                            <div className='d-flex align-items-center gap-2'>
                                <span>Show detailed view</span>
                                <Switch
                                    checked={showDetail}
                                    onChange={onSwitchChange}
                                />
                            </div>
                        }
                    >

                        <div className='note-placeholder mt-1 w-100'>
                            <div className='add-note-frame' >
                                <div className='comment-section'>
                                    <img className='user-image' src={Object.keys(props?.user?.data)?.length > 0 ? props.user?.data?.helios_user_setting?.avatar : require('../../assets/images/skel-user.png').default} alt='user' />
                                    <div className='comment-content' >
                                        {showEditor ?
                                            <DraftEditor setComment={setComment} setPlainComment={setPlainComment} />
                                            : <div className='input-section' onClick={() => {
                                                setSaved(false)
                                                setShowEditor(true)
                                            }}>
                                                <span>Add a comment...</span>
                                            </div>
                                        }
                                        <div className='d-flex flex-row flex-wrap gap-2'>
                                            {attachments?.map((attachment, index) => (
                                                <img
                                                    key={index}
                                                    alt={attachment.file_name}
                                                    src={attachment.mime_type === 'pdf' ? require('../../assets/images/pdf-icon.png').default : attachment?.file_path}
                                                    className='attachment' />
                                            ))}
                                        </div>
                                    </div>
                                    <div className='note-buttons'>
                                        <div className='d-flex' >
                                            {canCreateNote && !isSaved &&
                                                <button
                                                    className={`btn-save ${plainComment?.length < 4 && 'disable'}`}
                                                    disabled={plainComment?.length < 4 || isLoading}
                                                    onClick={() => onAddNote(false)}
                                                >  {isLoading ? <Spin size='small' /> : `Save `}</button>
                                            }
                                            {!isSaved &&
                                                <button className={`btn-arrow ${plainComment?.length < 4 && 'disable'}`}
                                                    disabled={plainComment?.length < 4 || isLoading}
                                                    onClick={() => setShowSendCustomerBtn((show) => !show)}
                                                >
                                                    <img alt="" src={require('../../assets/images/line.svg').default} />
                                                    <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path id="Icon Color" fillRule="evenodd" clipRule="evenodd" d="M12.5 1.57692L11.4091 0.5L6.5 5.34615L1.59091 0.5L0.5 1.57692L6.5 7.5L12.5 1.57692Z" fill="white" />
                                                    </svg>
                                                </button>
                                            }
                                            {isSaved &&
                                                <div className='d-flex' >
                                                    <button className={`btn-save btn-saved`} disabled={true}>{`Saved and Sent!`}</button>
                                                </div>
                                            }
                                            {showEditor &&
                                                <div className='close-btn' onClick={resetAllNoteState} >
                                                    <img alt="" src={require('../../assets/images/production_board/modal-close.svg').default} />
                                                </div>
                                            }
                                        </div>
                                        {canCreateNoteAndSend && showSendCustomerBtn &&
                                            <div className='d-flex justify-content-start w-100'>
                                                <button
                                                    className={`send-customer ${isInvalidCustomerEmail ? 'disable' : ''}`}
                                                    disabled={isInvalidCustomerEmail}
                                                    onClick={() => onAddNote(true)}
                                                >
                                                    {isInvalidCustomerEmail ? 'Invalid Customer Email' : 'Save and Send to Customer'}
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            {props.notesLoading ?
                                <Skeleton active />
                                :
                                <div className='notes'>
                                    {canSeeNote && props.notes.length > 0 &&
                                        props.notes.map((note, index) => {
                                            const now = new Date();
                                            const difference = differenceInMinutes(now, new Date(note.created_at));
                                            return (
                                                <div key={index} className='note-item'>
                                                    <div className='d-flex flex-row gap-2' >
                                                        <Avatar
                                                            className='sender-avatar'
                                                            imgClass='sender-avatar'
                                                            userImage={note?.sender?.helios_user_setting?.avatar}
                                                            userName={note?.sender}
                                                        />
                                                        <div className='d-flex flex-row gap-2 align-items-baseline'>
                                                            <span className='name'>{note?.sender?.firstname} {note?.sender?.lastname?.substring(0, 1)}.,</span>
                                                            <Tooltip title={moment(note.created_at).format("dddd MMMM DD, YYYY [at] hh:mma")} >
                                                                <span className='time'>{`${note?.sent_or_received} ${difference < 5 ? 'just now' : dateFormat(note.created_at, 'TXT_DATE')}`}</span>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                    <div className='note-message' dangerouslySetInnerHTML={{ __html: note.message }} />
                                                    <div className='d-flex flex-wrap gap-2'>
                                                        {note?.images && note?.images?.map((image, img_index) => {
                                                            return (
                                                                <div key={img_index} onClick={() => {
                                                                    setLightBoxImages(note?.images)
                                                                    setImageIndex(img_index)
                                                                    setOpenLightBox(true)
                                                                }}>
                                                                    {image.mime_type === "pdf" ?
                                                                        <img className='note-attachement' src={require('../../assets/images/pdf-icon.png').default} />
                                                                    :
                                                                        <img className='note-attachement' src={image?.file_path} />
                                                                    }
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            )
                                        }
                                        )
                                    }
                                </div>
                            }
                        </div>
                    </Block>
                </div>
            </div>
            </Spin>
            {/* light box images for notes */}
            {isOpenLightBox &&
                <Lightbox
                    mainSrc={lightBoxImages[imageIndex]?.file_path}
                    nextSrc={lightBoxImages[(imageIndex + 1) % lightBoxImages?.length]['file_path']}
                    prevSrc={lightBoxImages[(imageIndex + lightBoxImages.length - 1) % lightBoxImages.length]['file_path']}
                    onCloseRequest={() => setOpenLightBox(false)}
                    onMovePrevRequest={() =>
                        setImageIndex((imageIndex + lightBoxImages.length - 1) % lightBoxImages.length)
                    }
                    onMoveNextRequest={() =>
                        setImageIndex((imageIndex + 1) % lightBoxImages.length)
                    }
                    imageLoadErrorMessage={
                        <di>{lightBoxImages[imageIndex]['mime_type'] === 'pdf' ?
                            <iframe className='lightbox-iframe' title='pdf' src={lightBoxImages[imageIndex]['file_path']} ></iframe>
                            : 'This image failed to load'}
                        </di>
                    }
                    enableZoom={lightBoxImages[imageIndex]['mime_type'] === 'pdf' ? false : true}
                />
            }
            {
                archiveOpen &&
                <div className='archive-modal_overlay' onClick={() => handleCloseArchiveModal()}></div>
            }
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        jobStatuses: state.JobReducer.jobStatuses,
        colorList: state.JobReducer.colorList,
        assignableUsers: state.JobReducer.assignableUsers,
        notes: state.NoteReducer.notes?.data,
        vehicleMakes: state.JobReducer.vehicleMakes,
        user: state.UserReducer.user,
        newJob: state.JobReducer.newJob,
        customers: state.JobReducer.customers,
        customer: state.JobReducer.customer,
        countData: state.NoteReducer.countData,
        notesLoading: state.NoteReducer.notes.loading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getJobByOrg: () => dispatch(getJobByOrg()),
        getAllAssignableUsers: () => dispatch(getAllAssignableUsers()),
        createNewJob: (data, flag, isFirstJob) => debouncedCreateNewJob(dispatch, data, flag, isFirstJob),
        getNoteList: (jobId, isLog) => dispatch(getNoteList(jobId, isLog)),
        debouncedGetCustomers: (query) => debouncedGetCustomers(dispatch, query),
        debouncedGetChooseJob: (id, loading) => debouncedGetChooseJob(dispatch, id, loading),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(JobDetail);
